var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_79",
    "data-name": "Group 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.635,
    height: 43.755,
    viewBox: "0 0 44.635 43.755",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M9.538,41.094H1.313a1.313,1.313,0,1,1,0-2.625H9.538a1.313,1.313,0,1,1,0,2.625",
    transform: "translate(0 -33.768)",
    fill: "#2b3385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M73.322,12.026a6.013,6.013,0,1,1,6.013-6.013,6.02,6.02,0,0,1-6.013,6.013m0-9.4A3.388,3.388,0,1,0,76.71,6.013a3.392,3.392,0,0,0-3.387-3.388",
    transform: "translate(-59.083)",
    fill: "#2b3385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M204.137,41.094H184.516a1.313,1.313,0,1,1,0-2.625h19.621a1.313,1.313,0,0,1,0,2.625",
    transform: "translate(-160.814 -33.768)",
    fill: "#2b3385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M217.556,141.842a6.013,6.013,0,1,1,6.013-6.013,6.019,6.019,0,0,1-6.013,6.013m0-9.4a3.387,3.387,0,1,0,3.387,3.387,3.391,3.391,0,0,0-3.387-3.387",
    transform: "translate(-185.691 -113.952)",
    fill: "#2b3385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M22.4,170.9H1.313a1.313,1.313,0,0,1,0-2.626H22.4a1.313,1.313,0,0,1,0,2.626",
    transform: "translate(0 -147.712)",
    fill: "#2b3385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M296.539,170.9h-6.757a1.313,1.313,0,0,1,0-2.626h6.757a1.313,1.313,0,0,1,0,2.626",
    transform: "translate(-253.216 -147.712)",
    fill: "#2b3385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M61.3,271.655a6.013,6.013,0,1,1,6.013-6.013,6.02,6.02,0,0,1-6.013,6.013m0-9.4a3.388,3.388,0,1,0,3.388,3.387,3.391,3.391,0,0,0-3.388-3.387",
    transform: "translate(-48.532 -227.901)",
    fill: "#2b3385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M193.587,300.715H172.5a1.313,1.313,0,0,1,0-2.625h21.09a1.313,1.313,0,1,1,0,2.625",
    transform: "translate(-150.264 -261.661)",
    fill: "#2b3385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M8.069,300.715H1.313a1.313,1.313,0,0,1,0-2.625H8.069a1.313,1.313,0,0,1,0,2.625",
    transform: "translate(0 -261.661)",
    fill: "#2b3385"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon_settings.6d1afc7e40e406a0faee1d390fd3fc6b.svg";
export { ForwardRef as ReactComponent };